import { createSlice } from '@reduxjs/toolkit';
// eslint-disable-next-line import/no-cycle
import { RootState } from '../../store';

const uploadSlice = createSlice({
  name: 'upload',
  initialState: {},
  reducers: {
    addTransactions: (state, action) => {
      const { exchange, transactions } = action.payload;
      state[exchange] = transactions;
    },
    resetTransactions: (state) => {
      Object.keys(state).forEach(key => {
        delete state[key];
      });
    },
  },
});

export const { addTransactions, resetTransactions } = uploadSlice.actions;

export default uploadSlice.reducer;

export const selectCurrent = (state: RootState) => state.upload;
